export interface Part {
  id: string;
  label: string;
}

export const products = [
{
  id: 0,
  name: "Below Elbow Model",
  modelPath: "/models/hand.glb",
  parts: {
      base: "/models/base.glb",
      partA: "/models/partA.glb",
      partB: "/models/partB.glb",
      orings: "/models/orings.glb",
    },
  description: `
The Below Elbow Model is a precision-engineered medical support system
designed to provide optimal stability, comfort, and functional rehabilitation
for patients recovering from hand injuries or surgical procedures.

This model integrates advanced ergonomic principles with clinically tested
materials to ensure proper alignment of the thumb, palm, and fingers while
maintaining natural hand mobility. The modular design allows medical
professionals to selectively activate or deactivate support components based
on individual patient needs.

The Thumb Support module stabilizes the carpometacarpal and metacarpophalangeal
joints, helping reduce strain during gripping or pinching activities. It is
particularly effective for patients with ligament injuries, arthritis, or
post-operative recovery requirements.

The Palm Brace provides firm yet adaptive compression across the palmar region,
enhancing load distribution and minimizing excessive flexion. Its contoured
structure ensures even pressure without compromising circulation or comfort
during prolonged use.

The Finger Guard component protects delicate finger joints and tendons while
allowing controlled movement. This feature is especially beneficial in cases
of tendon repair, fractures, or rehabilitation therapies requiring gradual
mobility restoration.

Designed for both clinical demonstration and patient education, this
orthopedic hand model supports color and texture customization to visually
highlight specific anatomical or functional areas. Its high-fidelity 3D
representation makes it ideal for training, consultation, and product
showcase environments.

This model serves as a reliable solution for orthopedic specialists,
physiotherapists, and medical device manufacturers seeking a balance between
functional accuracy and visual clarity.
`
}

];
